import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Slider from 'components/molecules/Slider';
import {
  DEFAULT_SEARCH_DISTANCE,
  MAXIMUM_SEARCH_DISTANCE,
  MINIMAL_SEARCH_DISTANCE,
} from 'shared/config';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';

const DistanceSliderContainer = styled('div')(
  ({ theme }) => `
  margin-top: ${theme.spacing(0)};
  & .MuiSlider-root {
    margin-bottom: ${theme.spacing(0)};
  }`,
);

export const DistanceFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  return (
    <DistanceSliderContainer>
      <Typography id='classic-slider' color='primary' gutterBottom>
        Distance from your zip
      </Typography>
      <Slider
        name='distance'
        value={filters.distance || DEFAULT_SEARCH_DISTANCE}
        valueLabelFormat={(v) =>
          `${
            v === MAXIMUM_SEARCH_DISTANCE ? `${MAXIMUM_SEARCH_DISTANCE}+` : v
          } mi`
        }
        measurementUnit='mi'
        valueLabelDisplay='on'
        aria-labelledby='classic-slider'
        step={50}
        min={MINIMAL_SEARCH_DISTANCE}
        max={MAXIMUM_SEARCH_DISTANCE}
        track={false}
        onChangeCommitted={(e, value) => {
          if (disabled) {
            return;
          }
          setFilterValue('distance', value);
        }}
      />
    </DistanceSliderContainer>
  );
};
